import parse from 'html-react-parser';
const apiUrl = 'https://api.drugs4dent.com/';
const API_URL = 'https://api.drugs4dent.com/';

export function getDataVersion() {
    let url = 'https://sqn72kk00l.execute-api.ap-southeast-2.amazonaws.com/prod'
    try
    {
        return  fetch(`${url}/dataVersion`,
        {
            method:"GET",
            headers: {

                'Authorization':`Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
            }
        })
        .then(data => data.json())
      
    }
    catch(error)
    {
        return [];
    }
}
export async function getProductImage(shapeids,colourids,scoring,mimsclassname,marking,companyid,brandid,symboldid,formid,moleculeid,colorMatching,fetchPage) {
    //getToken();
    //alert(brandid)
    try
    {
        let url = `${apiUrl}productImage/search?brandId=${brandid}`
        let res =  await fetch(url,
        {
    
            method:"GET",
            headers: {
                // 'api-key': '191a3bca840c4db7bd8f3bcf81974e56',
                // 'Content-Type': 'application/json',
                // 'Accept': 'application/json',
                'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`
            }
        })
        
        let json = await res.json();
        var count = parseInt(res.headers.get('total-count'));
        var page = parseInt(res.headers.get('page-index'));
        return {success:true, count:count, page:page, data:json};
        
    }
    catch(error)
    {
        return {success:false, count:0, page:0, data:[]};
    }
}

export async function getAbbrPiByID(input) {
    //getToken();
    //alert('sdfsdfsdf')

    try {
        //return  fetch(`https://stagsgwsapim.azure-api.net/au/referenceproduct/v2/abbrevPI/${encodeURIComponent(data.ProductName)}`,
        //return  fetch(`${process.env.REACT_APP_API_URL}/abbrevPI/3e153a57-973c-4bf4-8f1d-a533011fc820`,
        return await fetch(`${apiUrl}AbbreviatedPi/abbrevPI?abbrevPiId=${input}`,
            {

                method: "GET",
                headers: {
                    // 'api-key': '191a3bca840c4db7bd8f3bcf81974e56',
                    // 'Content-Type': 'application/json',
                    // 'Accept': 'application/json',
                    //'Authorization': `Bearer ${localStorage.getItem('token').replaceAll('"', "")}`
                    'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`
                }
            })
            .then(data => data.json());
    }
    catch (error) {
        return [];
    }
}
// export async function getAbbrPiByID(input){
//     //getToken();
   
   
//     try
//     {
//         //return  fetch(`https://stagsgwsapim.azure-api.net/au/referenceproduct/v2/abbrevPI/${encodeURIComponent(data.ProductName)}`,
//         //return  fetch(`${apiUrl}/abbrevPI/3e153a57-973c-4bf4-8f1d-a533011fc820`,
//         return await fetch(`${apiUrl}/AbbreviatedPi/abbrevPI/${encodeURIComponent(input)}`,
//         {
    
//             method:"GET",
//             headers: {
//                 // 'api-key': '191a3bca840c4db7bd8f3bcf81974e56',
//                 // 'Content-Type': 'application/json',
//                 // 'Accept': 'application/json',
//                 'Authorization':`Bearer ${localStorage.getItem('token')}`
//             }
//         })
//         .then(data => data.json());
//     }
//     catch(error)
//     {
//         return [];
//     }
// }
export async function getDrugInfo(input) {
    try
    {
        let response = await fetch(`${apiUrl}drugInfo/${encodeURIComponent(input)}`,
        {
            method:"GET",
            headers: { 'Authorization':`Bearer ${localStorage.getItem('sessionId').replaceAll('"', "")} ${localStorage.getItem('Activecountryversion').replaceAll(" ", "")}`,}
        });
        return await response.json();
    }
    catch(error)
    {
        return  [];
    }
}
 export function cleanUpAnchor (input) {
    input= input.replace(/ /g, '_').replace('(','').replace(')','').replace(',','').replace('/','_').replace('.','_').replace(':','_').replace('[','').replace(']','').replace('%','');
    input= '_'+input;
    return input;
  }

 export function httpHtml(content) {
    if (content && content != "") {
      const brPlaceholder = ' ___BR_PLACEHOLDER___';

      // Replace <br /> with a placeholder
      content = content.replace(/<br\s*\/?>/gi, brPlaceholder);
      
      // Perform content modifications
      content = content.replace(/\n/g, "<br />");
      const reg =
        /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
        content = content.replace(reg, function(match, p1) {
            var url = p1.replace(/\.$/, ''); 
            return '<a href="' + url + '">' + url + '</a>';
          });
      content = content.replace(/href="(?!http)/, 'target="_blank" href="https://');
      content = content.replaceAll(".</a>", "</a>.");
      content = content.replaceAll(")</a>", "</a>)");
      
      // Restore <br /> tags
      content = content.replace(new RegExp(brPlaceholder, 'g'), '<br />');

      //add target blank
      var c = content.split('<a href=')
      content = c.join("<a target=\"_blank\" href=")
    }

   
    return content;
  }
export function GetListCountryVersion() {
    
    try
    {
        return  fetch(`${API_URL}api/MimsDrug4dent/GetCountryVersion`,
        {
            method:"GET",
            
        })
        .then(data => data.json())
      
    }
    catch(error)
    {
        return [];
    }
}


export function cleanUp(text) {
    let s = text ?? ''
    if(s.includes("\\r\\n")) {
        s = `<p>${s}</p>`
        s = s.split("\\r\\n").join("</p><p>")
    }
    else s = s.split("\\r\\n").join("<br /><br />")
    
    s = s.replace('contains molecule', 'contains')
    s = s.replace('containing:', 'containing ')
    s = s.split(">=").join("&ge;")
    s = s.split('\\"').join('"')
    return parse(s)
}
export function cleanUpDosing(text) {
    let s = text ?? "";

    if (s.includes("\\r\\n")) {
        s = s.split("\\r\\n").join("</p><p>");
    } else {
        s = s.split("\\r\\n").join("<br /><br />");
    }

    s = s.replace("contains molecule", "contains");
    s = s.replace("containing:", "containing ");
    s = s.split(">=").join("&ge;");
    s = s.split('\\"').join('"');

    // Contraindications
    s = s.replace(
        /Contraindications:\s*(.*?)(?=<\/p><p>Precautions:|Precautions:|$)/is,
        (_, contraindications) =>
            `</p><h5>Contraindications:</h5><p>${contraindications.trim()}</p>`
    );

    // Precautions
    s = s.replace(
        /Precautions:\s*(.*?)(?=<\/p><p>Precautions:|Precautions:|$)/is,
        (_, Precautions) =>
            `</p><h5>Precautions:</h5><p>${Precautions.trim()}</p>`
    );

    return parse(s);
}